export const customsDeclarations = {
  title: 'Customs declarations',
  resourceName: 'Customs declarations',
  titles: {
    list: 'Customs declaration list',
    detail: 'Customs declaration details',
    create: 'Add customs declaration',
    edit: 'Edit customs declaration',
    addQuick: 'Quick add',
  },
  sections: {
    linkage: 'Shipment & HS code',
    product: 'Product & specs',
    origin: 'Origin & manufacturer',
    commercial: 'Quantity & pricing',
    tax: 'Tax',
    note: 'Notes',
    audit: 'System',
  },
  filter: {
    all: 'All shipments',
  },
  hints: {
    imageLines: 'One per line or comma-separated',
  },
  fields: {
    loHang: 'Shipment',
    maHs: 'HS code',
    trongLuong: 'Weight (kg)',
    tenYeuCauXuatHoaDon: 'Invoice title requested',
    tenThuongHieu: 'Brand',
    model: 'Model',
    moTaSanPham: 'Product description',
    hinhAnhSanPham: 'Product images',
    linkSanPham: 'Product link',
    thongSoKyThuat: 'Technical specs',
    kichThuoc: 'Dimensions',
    chieuDai: 'Length',
    chieuRong: 'Width',
    chieuCao: 'Height',
    theTich: 'Volume',
    congSuat: 'Power / rating',
    nhaSanXuat: 'Manufacturer',
    diaChiNhaMay: 'Factory address',
    nuocXuatXu: 'Country of origin',
    soLuong: 'Quantity',
    donVi: 'Unit',
    donGia: 'Unit price',
    thanhTien: 'Amount',
    loaiTienTe: 'Currency',
    thueVat: 'VAT (%)',
    soTienThue: 'Tax amount',
    ghiChu: 'Notes',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
  },
  messages: {
    noData: 'No customs declarations yet',
    exportSuccess: 'Customs declarations exported successfully',
    exportFailed: 'Failed to export customs declarations',
  },
}
